import { SuccessTokenStepResponse } from "@shared/services";

export const intervalMiliseconds = (
  SuccessTokenStepResponse: SuccessTokenStepResponse | undefined
): number => {
  return SuccessTokenStepResponse?.not_before
    ? (SuccessTokenStepResponse.not_before -
        SuccessTokenStepResponse.issued_at) *
        1000
    : 0;
};

export const delay = (miliseconds: number): Promise<void> => {
  if (miliseconds <= 0) return Promise.resolve();
  return new Promise<void>((resolve) => setTimeout(resolve, miliseconds));
};

export const currentTimestamp = (): number => {
  const now = new Date();
  const oneSecondBefore = new Date(now.getTime() - 1000);
  return Math.floor(oneSecondBefore.getTime() / 1000);
};

export function delayIfInRange(tokenResponse: SuccessTokenStepResponse | undefined, maxMs: number = 5000): Promise<void> {
  const ms = intervalMiliseconds(tokenResponse);
  if (ms > 0 && ms < maxMs) return delay(ms);
  return Promise.resolve();
}